import { supabase } from './supabaseClient';

/**
 * Wrapper around fetch that automatically includes Supabase auth token
 * Use this for authenticated API calls to Azure Functions
 */
export async function authenticatedFetch(url: string, options: RequestInit = {}): Promise<Response> {
  // Read session and attempt a refresh when access token is missing/stale.
  const { data: { session } } = await supabase.auth.getSession();
  let accessToken = session?.access_token ?? null;

  if (!accessToken) {
    const { data } = await supabase.auth.refreshSession();
    accessToken = data.session?.access_token ?? null;
  }

  // Merge headers with authorization token when available.
  const headers = new Headers(options.headers);

  if (accessToken) {
    headers.set('Authorization', `Bearer ${accessToken}`);
    headers.set('X-Supabase-Authorization', `Bearer ${accessToken}`);
  }

  return fetch(url, {
    ...options,
    headers,
    // Keep cookies available as a fallback auth signal behind SWA proxying.
    credentials: options.credentials ?? 'include',
  });
}
